var map = {
	"./agent-card.svg": "mDiE",
	"./agent.svg": "CTbz",
	"./agents.svg": "hYan",
	"./alert-badge.svg": "bvdv",
	"./alert-configuration-active.svg": "RPfj",
	"./alert-configuration.svg": "HzNg",
	"./alert-warning.svg": "S8KX",
	"./alert.svg": "lRUU",
	"./alerts-history.svg": "Sazq",
	"./away.svg": "QMnl",
	"./back-soon.svg": "ab6o",
	"./bot-card.svg": "Z3Bw",
	"./bot-graph-card.svg": "qH4e",
	"./bot-graph-left-arrow.svg": "QWGV",
	"./bot-graph-table.svg": "uaNF",
	"./bot.svg": "W6An",
	"./broken-image.svg": "ACXF",
	"./clock-for-timeframe.svg": "RsXY",
	"./close-icon.svg": "rxOk",
	"./closed.svg": "o2mc",
	"./collapse-widget.svg": "vtNB",
	"./counter-clockwise-arrow.svg": "UHtT",
	"./dropdown-arrow.svg": "wLf9",
	"./empty-state-agents.svg": "Vvp+",
	"./empty-state-bots.svg": "hCyj",
	"./empty-state-conversation.svg": "/BWc",
	"./error-on-metric.svg": "U3C/",
	"./error-on-widget.svg": "J+py",
	"./expand.svg": "9iEh",
	"./filter-stroke.svg": "BgBd",
	"./folder-closed.svg": "d0Wc",
	"./groups.svg": "273X",
	"./horizontal-resize-handle.svg": "0TGS",
	"./in-queue.svg": "sAjZ",
	"./info.svg": "0zMN",
	"./manager-workspace-regular.svg": "154u",
	"./manager-workspace-selected.svg": "lUQx",
	"./menu-groups.svg": "g5mg",
	"./menu.svg": "bsuW",
	"./metrics-configuration.svg": "TabY",
	"./offline.svg": "xdr4",
	"./online.svg": "Kny0",
	"./open.svg": "6PLz",
	"./plus-sign.svg": "ZzTF",
	"./resizing-theme-dark.svg": "eke6",
	"./resizing-theme-light.svg": "Pasg",
	"./side-chat.svg": "m1eD",
	"./skills.svg": "jtwL",
	"./status-away.svg": "+cQv",
	"./status-back_soon.svg": "dHUv",
	"./status-online.svg": "Fgw2",
	"./table.svg": "D1CD",
	"./timeframe.svg": "oNyJ",
	"./update-error.svg": "GNno",
	"./x-for-tags.svg": "KLy/"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "etd4";